import React from "react";
import { useMediaQuery } from "react-responsive";

function WeclomeSection() {
  const isLaptop = useMediaQuery({ query: "(max-width: 999px)" });
  return (
    <div className="pin-top setup-page  full-width" style={{display:isLaptop&&"none"}} >
      <h1 className="white-text ">👋 Welcome Back</h1>
      <h1 className="margin-0px">To Cercle-X Auction !</h1>

      <p
        className="font-cercular-light mb-2 mt-2"
        style={{
          letterSpacing: "0.8px",
          width: "320px",
          lineHeight: "30px"
        }}
      >
        Discover the ultimate auction platform for buying and selling scraps.
        Unlock the best deals, maximize profits, and join a thriving community
        transforming waste into wealth.
      </p>

      <a
        className="flex align-center gap-1 hover white-text "
        href="https://cerclex.com/"
      >
        <b>Book Call Now</b>
        <span className="material-icons-outlined  ">arrow_right_alt</span>
      </a>
    </div>
  );
}

export default WeclomeSection;
